import LegalEntity from '../interfaces/legal-entity';
import { HttpClient } from './http-client';

export class VidService extends HttpClient {
  validatePerson(code: string, name: string) {
    return this.get<LegalEntity>(
      `/api/services/vid/person/validate/${code}/${name}`
    );
  }
}
